/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M10.3333 1.1233 9.6842.002 9.035 1.1233.7846 15.3742.1328 16.5h5.9389c0 .0457.004.0919.0126.1385.905 4.8878 5.6009 8.1165 10.4887 7.2116 4.8879-.905 8.1166-5.6009 7.2117-10.4887-.905-4.8878-5.6009-8.1166-10.4887-7.2116a.7503.7503 0 0 0-.0467.0101l-2.916-5.0366Zm3.7213 6.4277 4.5292 7.8232.6518 1.1258h-11.65c.8145 3.9976 4.6862 6.6208 8.7144 5.8751 4.0731-.7542 6.7638-4.6675 6.0096-8.7406-.724-3.911-4.3608-6.5474-8.255-6.0835ZM9.6842 2.996 16.6338 15H2.7346L9.6842 2.9961Z"
    clipRule="evenodd"
  />,
  'Develop'
);
